export default class transactionDetail {
  constructor() {
    this.noteNumber = '';
    this.note = {
      interestRate: 0,
    };
    this.user = {
      name: '',
    };
    this.amount = 0;
    this.createdAt = '';
    this.updatedAt = '';
    this.dwollaTransferId = '';
    this.status = '';
    this.failureReason = '';
  }
}



// WEBPACK FOOTER //
// ./src/entities/transactionDetail.js